import { ProductQuiz } from "@/components/quiz/ProductQuiz";

export const QuizSection = () => {
  return (
    <section className="section-padding bg-secondary/30">
      <div className="container-calim max-w-3xl">
        <ProductQuiz />
      </div>
    </section>
  );
};
